export default [
  // 使用优惠券
  {
    path: '/coupon/couponUsableList',
    name: 'couponUsableList',
    meta: { type: 'page', title: '使用优惠券', stParams: {} },
    component: () => import(/* webpackChunkName: 'coupon' */ 'views/coupon/usable')
  },
  // 直接两圈
  {
    path: '/coupon/direct',
    name: 'couponDirect',
    meta: { type: 'page', title: '优惠券领取', stParams: {} },
    component: () => import(/* webpackChunkName: 'coupon' */ 'views/coupon/direct')
  }
]
